export const CONSTANT = {
                            initialValue:{
                                            job_title: '',
                                            candidate_name:'',
                                            important:'',
                                            non_interview:''
                                         }
                            
                        }